import { SET_WORD_CLOUD } from "./actionTypes";

export const setWordCloud = (words) => {
    return {type: SET_WORD_CLOUD, words}
}